<script lang="ts">
	// eslint-disable-next-line no-restricted-imports
	import { P } from "flowbite-svelte";
	import type { ComponentProps } from "svelte";

	type $$Props = ComponentProps<P> & { secondary?: boolean };

	const baseColor = "text-gray-600 dark:text-gray-300";
	const secondaryColor = "text-gray-500 dark:text-gray-400";

	export let color: string | undefined = undefined;
	export let secondary = false;

	$: fontColor = color ?? (secondary ? secondaryColor : baseColor);
</script>

<P {...$$restProps} color={fontColor}><slot /></P>
